import { MappedClass, MappedProperty } from '@h5s/util-object';
import { ZPrinterPrintTransactionItemType } from './z-printer-print-transaction-item-type';

@MappedClass()
export class ZPrinterWarning {
  @MappedProperty()
  public code?: string | null;

  @MappedProperty()
  public description?: string | null;

  @MappedProperty({
    fromDto: 'source_type',
    toDto: 'source_type',
  })
  public sourceType?: ZPrinterPrintTransactionItemType | null;
}
